import { useQuery } from "@tanstack/react-query"
import { Axios } from "../utils/Axios"

export const useCategory = () => {
    return useQuery({
        queryKey: ['category'],
        queryFn: async () => {
            const res = await Axios.get('/category/all')
            return res.data?.data
        }
    })
}